"use client";

import { SubscriptionPlansModal } from "@/components/subscription-plans-modal";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Lock } from "lucide-react";
import Image from "next/image";
import { useState } from "react";

export function SlackIntegrationPaywall() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Card className="relative border-dashed border-2">
        <div className="absolute inset-0 bg-gradient-to-br from-background/80 via-background/90 to-background z-10" />
        <CardHeader className="relative z-20">
          <CardTitle>
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 bg-[#4A154B]/50 rounded flex items-center justify-center shrink-0 opacity-50">
                <Image
                  src="/images/logos/slack.svg"
                  alt="Slack logo faded"
                  width={16}
                  height={16}
                  className="opacity-75"
                />
              </div>
              <span className="text-muted-foreground">Slack Integration</span>
            </div>
          </CardTitle>
          <CardDescription className="text-muted-foreground/80">
            Connect Slack to receive real-time notifications for new leads.
          </CardDescription>
        </CardHeader>

        <CardContent className="relative z-20">
          <div className="flex flex-col items-center text-center py-8 px-4 rounded-lg bg-muted/50 border border-border/50">
            <div className="p-3 rounded-full bg-primary/10 mb-4 border border-primary/20">
              <Lock className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-lg font-semibold mb-2">
              Upgrade to Unlock Slack Integration
            </h3>
            <p className="text-sm text-muted-foreground mb-6 max-w-sm">
              Automate your lead flow by sending new opportunities directly to
              your Slack workspace. Upgrade your plan to enable this
              integration.
            </p>
            <Button
              onClick={() => setIsModalOpen(true)}
              className="font-semibold"
            >
              View Upgrade Options
            </Button>
          </div>
        </CardContent>
      </Card>

      <SubscriptionPlansModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
